module.exports = __webpack_public_path__ + "img/UAE-landscape-arabic.c5e2ced3.jpg";